import { AppBar, Box, Toolbar } from '@material-ui/core';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';

import Logo from 'src/components/Logo';

import Account from './Account';
import { useStyles } from './index.style';
import Notifications from './Notifications';
import Search from './Search';
import Settings from './Settings';
import { TopBarProps } from './types';

const TopBar = ({ className, ...rest }: TopBarProps) => {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box ml={2} flexGrow={1} />
        {/* 
        // TODO: Add once the feature is implemented
        <Search /> 
        <Notifications /> 
        */}
        <Settings />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
